module.exports = __webpack_public_path__ + "static/media/nakin.9b9bda6f.jpg";